// ignore-string-externalization
import * as Sentry from '@sentry/react';
import { getHash } from '../../../features/src/env';
import { beforeSend } from './beforeSend';

export function initSentry() {
  if (process.env.NODE_ENV !== 'production') return;

  Sentry.init({
    dsn: 'https://b77895087f0946d4b6baf7b3e1d9b999@o22381.ingest.sentry.io/4504498620268544',
    release: getHash(),
    sampleRate: 0.2,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.thirdPartyErrorFilterIntegration({
        filterKeys: ['artists-spotify-com'],
        behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
      }),
    ],
    tracesSampleRate: 0.05,
    tracePropagationTargets: [/^https:\/\/artists\.spotify\.com/],
    allowUrls: [/artists\.spotify\.com/, /mrkt\.spotifycdn\.com/],
    denyUrls: [/otBannerSdk/, /otSDKStub/],
    ignoreErrors: [
      // Native WebView bridges — no stack frames, so the third-party
      // filter can't catch them
      /window\.webkit\.messageHandlers/,
      /Script message handler.*unavailable/,
      // Sentry's own payload rejection
      /PAYLOAD_SIZE_LIMIT_EXCEEDED/,
      // Transport library throws on logged-out users (unhandled rejection bug)
      /^(Transport)?Error: logged out$/,
      // Browser autoplay policy — video.play() interrupted when browser pauses
      // background media to save power. Expected behavior, not a bug.
      /play\(\) request was interrupted/,
      // Contentful client-side network failures — user's browser lost
      // connectivity or navigated away mid-fetch. Not actionable.
      /AxiosError: timeout of \d+ms exceeded/,
      /AxiosError: Request aborted/,
      /AxiosError: Network Error/,
      // Frames are in bundled react-dom/scheduler, so the third-party
      // filter stamps them as first-party
      /^TypeError: Illegal invocation$/,
      // Browser fetch failures — user went offline or navigated away mid-request.
      // Not actionable on a logged-out marketing site.
      /^TypeError: Failed to fetch$/,
      /^TypeError: NetworkError when attempting to fetch resource\.$/,
      /^TypeError: cancelled$/,
      // Transport library rejects with a response object on network failure
      // (status 0). No stacktrace, not actionable.
      /Object captured as promise rejection with keys: body, headers, metadata, offline, ok, retries, status, timing, url/,
      // Empty promise rejections with no keys or stacktrace — third-party
      // scripts or browser quirks, completely undiagnosable.
      /Object captured as promise rejection with keys: \[object has no keys\]/,
      // Instagram in-app browser injects scripts referencing window._META
      /window\._META\.IABInnerFrame/,
      // TikTok/Android WebView Java bridge failures
      /Java object is gone/,
      /Java bridge method invocation error/,
      // Silent auth iframe cross-origin check — expected on logged-out pages
      /Blocked a frame with origin.*from accessing a cross-origin frame/,
      // Crypto wallet extensions disconnecting from chains (EIP-1193)
      /The provider is disconnected from all chains/,
      // Browser fails to decode inline base64 SVG data URIs (encore logos)
      /Unable to load image data:image\/svg\+xml;base64/,
      // Autofill extension injects script referencing "xbrowser" via setTimeout;
      // Sentry's bundled wrapper gives it a first-party frame, bypassing the
      // third-party filter
      /xbrowser is not defined/,
    ],
    beforeSend,
  });
}
